<template>
  <v-layout
    column
    class="mt-2"
  >
    <v-flex
      fill-height
      align-center
    >
      <v-btn
        color="primary"
        small
        icon
        :loading="loading"
        @click="showNoteDialog('add')"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-dialog
        v-model="noteDialog"
        persistent
        width="500"
      >
        <v-card>
          <v-card-text>
            <v-form>
              <v-textarea
                v-model="note"
                label="Заметка"
              />

              <v-btn
                small
                color="primary"
                :loading="loading"
                @click="save"
              >
                Ок
              </v-btn>
              <v-btn
                small
                @click="noteDialog = false"
              >
                Отмена
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>
    <v-flex
      class="pa-1 worked-variant-table"
      :style="{
        height: '155px',
        'overflow-y': 'auto',
        'overflow-x': 'hidden'
      }"
    >
      <v-list>
        <v-list-tile
          v-for="item in notes"
          :key="item.id"
          class="compact"
        >
          <v-list-tile-content>
            <div>
              <span style="color: rgba(0,0,0,.54);">{{ item.author }}: {{ item.date | dateTime }} </span><span> {{ item.text }}</span>
            </div>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-layout>
              <span>
                <v-icon @click="showNoteDialog('change', item.id, item.text)">edit</v-icon>
              </span>
              <span>
                <v-icon @click="deleteNote(item.id)">delete</v-icon>
              </span>
            </v-layout>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-flex>
  </v-layout>
</template>
<script>
import {
  getNotes,
  createRouteNote,
  updateRouteNote,
  deleteRouteNote,
} from "../../../backend/routesApi.js";

export default {
  props: ["id"],
  data() {
    return {
      notes: [],
      action: null,
      noteDialog: false,
      note: "",
      noteId: 0,
      loading: false,
    };
  },
  created() {
    this.getNotes();
  },
  methods: {
    async getNotes() {
      this.loading = true;
      this.notes = await getNotes(this.id);
      this.loading = false;
    },
    save() {
      if (this.action === "add") {
        this.addNote();
      } else if (this.action === "change") {
        this.changeNote();
      }
    },
    async addNote() {
      try {
        this.loading = true;
        await createRouteNote(this.id, this.note);
        this.loading = false;
      } catch (error) {
        if (error.message) {
          this.loading = false;
          this.noteDialog = false;
          this.showError(error.message);
        } else {
          this.loading = false;
          throw error;
        }
      }
      this.noteDialog = false;
      this.note = "";
      this.noteId = 0;
      this.action = null;
      await this.getNotes();
    },
    async changeNote() {
      await updateRouteNote(this.id, this.noteId, this.note);
      this.noteDialog = false;
      this.note = "";
      this.noteId = 0;
      this.action = null;
      await this.getNotes();
    },
    async deleteNote(noteId) {
      await deleteRouteNote(this.id, noteId);
      await this.getNotes();
    },
    showNoteDialog(action, noteId, note) {
      this.action = action;
      this.noteId = noteId;
      this.note = note;
      this.noteDialog = true;
    },
  },
};
</script>
